import { object, string } from 'yup'

export const signinSchema = object().shape({
  email: string().email().required(),
  password: string()
    .required('Password is required')

    .strict(true),
})
